<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 1500px"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSegment">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Segmentos
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="elements"
          :openDialog="openDialog"
          :title="title"
          @goToItem="goToDfis"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="elements"
          :headers="allHeaders"
          :title="title"
          :goToItem="goToDfis"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
    </v-col>
    <v-dialog
      v-model="openElement"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <FormElement
        @save="saveForm"
        @cancel="reset"
        :mode="mode"
        :itemsElement="itemSelected"
      >
      </FormElement>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>
<script>
import schedules from "../../../store/permisosDeAcceso/accessPermissions";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormElement from "./Forms/FormElement.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import process from "@/store/workflow/process";
import moment from "moment";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DeleteDialog,
    Snackbar,
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    FormElement,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: "Elementos",
      titleTable: "PermisosDeAcceso_Elementos",
      titleDelete: this.$tc("schedules.toElement"),
      color: "",
      alert: false,
      textAlert: "",
      isLoading: true,
      itemsRequired: [
        { id: 0, name: "No" },
        { id: 1, name: "Si" },
        { id: 2, name: "No definido" },
      ],
      headers: [
        {
          text: "Elementos",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Entrada",
          value: "fromMinutes",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Salida",
          value: "toMinutes",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Aplica feriados",
          value: "applyOnHolidaysIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Aplica no feriados",
          value: "applyOnNonHolidaysIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require Cacheo",
          value: "requiredCacheoIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Porcentaje Cacheo",
          value: "porcentCacheo",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require Pin",
          value: "requiredPinIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require PassBack",
          value: "requiredPassBackIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          visible: true,
          class: "primary secondary--text",
          sortable: false,
          width: "100px",
        },
      ],
      idElement: null,
      itemSelected: {},
    };
  },
  mounted() {
    schedules.dispatch("getElements").then(() => {
      schedules.dispatch("getAllDfis");
      this.isLoading = false;
    });
     configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    segment() {
      return schedules.state.segments;
    },
    allDfis() {
      return schedules.state.allDfis;
    },
    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    padding() {
      return schedules.state.paddingNav;
    },
    elements() {
      return schedules.state.elements;
    },
    openElement: {
      get() {
        return schedules.state.openElement.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return schedules.state.openDeleteEle;
      },
      set(newvalue) {
        return newvalue;
      },
    },

    dataElement() {
      return {
        timeFrom: null,
        timeTo: null,
        element: {
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
        from: {
          label: this.$tc("date.from"),
          data: "00:00",
          type: "time",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        to: {
          label: this.$tc("date.to"),
          data: "00:00",
          type: "time",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
        noHolidays: {
          label: this.$tc("schedules.applyNotHoliday"),
          data: false,
        },
        holidays: { label: this.$tc("schedules.applyHolidays"), data: false },
        requiredPin: {
          label: "Require pin",
          data: this.itemsRequired[2],
          items: this.itemsRequired,
          itemsValue: "id",
          itemsText: "name",
        },
        dfis: {
          label: "DFis",
          data: [],
          items: this.allDfis,
          itemsValue: "id",
          itemsText: "name",
        },
        requiredCacheo: {
          label: "Require cacheo",
          data: this.itemsRequired[2],
          items: this.itemsRequired,
          itemsValue: "id",
          itemsText: "name",
        },
        requiredPassBack: {
          label: "Require passback",
          data: this.itemsRequired[2],
          items: this.itemsRequired,
          itemsValue: "id",
          itemsText: "name",
        },
        porcentage: {
          label: this.$tc("schedules.porcentage"),
          data: 0,
          type: "number",
          rules: [
            (v) => v <= 100 || this.$tc("schedules.rulesPorcentage"),
            (v) => v >= 0 || this.$tc("schedules.rulesPorcentage"),
          ],
        },
      };
    },
  },

  methods: {
    async refreshItems() {
      await schedules.dispatch("getElements");
    },
    goToSegment() {
      schedules.dispatch("handleShowWindow", "segment");
    },
    goToDfis(item) {
      schedules.commit("setElementId", item.id);
      schedules.dispatch("handleShowWindow", "dfis");
    },
    async openDialog(type, item) {
      await process.dispatch("getConcept").then(() => {
        this.itemSelected = this.dataElement;
        this.typeForm = type;
      });

      let payload = {
        type: "card",
        value: true,
      };

      switch (this.typeForm) {
        case "add":
          schedules.commit("setMode", this.$tc("schedules.addElement"));
          schedules.commit("setOpenElement", payload);
          this.mode = "Agregar elemento";

          break;
        case "edit":
          this.idElement = item.id;
          schedules.commit("setElementId", item.id);
          await schedules.dispatch("getDfis");
          schedules.commit("setMode", this.$tc("schedules.editElement"));
          schedules.commit("setOpenElement", payload);
          this.mode = "Editar elemento";
          this.itemSelected.dfis.data = schedules.state.dfis;
          this.itemSelected.noHolidays.data = item.applyOnNonHolidays;
          this.itemSelected.holidays.data = item.applyOnHolidays;
          this.itemSelected.requiredPin.data = item.requiredPin;
          this.itemSelected.requiredPassBack.data = item.requiredPassBack;
          this.itemSelected.porcentage.data = item.porcentCacheo;
          this.itemSelected.requiredCacheo.data = item.requiredCacheo;
          this.itemSelected.element.data = item.name;

          this.itemSelected.timeFrom = moment()
            .startOf("day")
            .add(item.from, "minutes")
            .format("HH:mm");
          this.itemSelected.timeTo = moment()
            .startOf("day")
            .add(item.to, "minutes")
            .format("HH:mm");

          break;
        case "delete":
          this.idElement = item.id;
          schedules.commit("setOpenDeleteEle", true);
          break;

        default:
          break;
      }
    },

    cardView(value) {
      this.showCard = value;
    },
     updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addElement(items);
          break;
        case "edit":
          this.editElement(items);
          break;
        default:
          break;
      }
    },
    addElement(items) {
      schedules.commit("setNewElement", items);
      schedules
        .dispatch("addElement")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addElementAlert");
        })
        .catch((e) => {
          this.catchError(e);
        });
      this.reset(false);
    },
    editElement(items) {
      let payload = {
        ...items,
        id: this.idElement,
      };
      schedules.commit("setEditElement", payload);
      schedules
        .dispatch("editElement")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.editElementAlert");
        })
        .catch((e) => {
          this.catchError(e);
        });
      this.reset(false);
    },
    convertMinutesToHHMM(minutes) {
      const hours = Math.floor(minutes / 60);
      const minutesRemainder = minutes % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutesRemainder).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    },
    catchError(e) {
      this.color = "#FF8D58";
      this.alert = true;
      this.textAlert = e.response.data.error.message;
    },

    reset(value) {
      schedules.commit("setOpenElement", value);
      this.alert = false;
      this.dataElement.element.data = "";
      this.dataElement.timeFrom = null;
      this.dataElement.timeTo = null;
      this.dataElement.requiredPin.data = 2;
      this.dataElement.requiredCacheo.data = 2;
      this.dataElement.requiredPassBack.data = 2;
      this.dataElement.porcentage.data = 0;
      this.dataElement.noHolidays.data = true;
      this.dataElement.holidays.data = false;
    },
    deleteItem() {
      schedules.commit("setItemDelete", this.idElement);
      schedules
        .dispatch("deleteElement")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.deleteElement");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.openDelete = false;
      schedules.commit("setOpenDeleteEle", false);
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteEle", false);
    },
  },
};
</script>
<style scoped></style>
